var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-rate"},[_c('el-rate',{attrs:{"disabled":"","show-score":"","text-color":"#666","colors":['#d0011b', '#d0011b', '#d0011b'],"disabled-void-color":"#aaa"},model:{value:(_vm.score),callback:function ($$v) {_vm.score=$$v},expression:"score"}}),_vm._v(" "),_c('span',[_vm._v("评分人次："+_vm._s(_vm.totalScoreNum))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7344b6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceRate.vue
// module id = null
// module chunks = 